import '../styling/Home.css';
import React, { useState } from "react";
import {FaUpload, FaPlus, FaPen, FaArrowRight, FaTag, FaPalette, FaThLarge, FaFilter, FaLock} from 'react-icons/fa';
import { Link, Navigate, useNavigate } from "react-router-dom";

import { getAuth, createUserWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import app from "../utils/firebase";

import customize1 from '../assets/customize-1.png';
import customize2 from '../assets/customize-2.png';
import customize3 from '../assets/customize-3.png';

const auth = getAuth(app);

const Home = () => {
  const [isAuthenticated, setAuthenticated] = React.useState(false);
  const [boxClicked, setBoxClicked] = React.useState(false);
  const [url, setUrl] = React.useState("");

  const navigation = useNavigate();

  const boxSubmit = () => {

    onAuthStateChanged(auth, (user) => {
      if (user) {
        setAuthenticated(true);
        setBoxClicked(true);
      } else {
        setAuthenticated(false);
        setBoxClicked(true);
      }
    });
    
  }
    return (
      <div className="App">
        {isAuthenticated && boxClicked && (
          // <Navigate to={"/dashboard"} state={{url}} />
          navigation("/dashboard", {state: {startUrl: url}})
        )}
        {!isAuthenticated && boxClicked && (
          <Navigate to="/signup" />
        )}
        <header className="App-header">
          <div className="header">
            <h1 className="headerTitle">Google Sheets has<br/>a new superpower.</h1>
            <p className="headerDesc">Sheet2Feed converts your spreadsheet into a beautiful, filterable, shareable web feed — in minutes. No code required.</p>
            <div className="hero-input-row">
              <input className="headerBoxTextBox" value={url} onChange={ev => setUrl(ev.target.value)} type="text" placeholder="Paste your Google Sheet URL to get started..." />
              <button className="headerBoxButton" onClick={boxSubmit}>
                Get Started <FaArrowRight size={13} style={{marginLeft: 6}}/>
              </button>
            </div>
            <p className="hero-hint">Free to use · No credit card required</p>
          </div>

          <div className="about" id="about">
            <h1>Launch Your Feed In <strong>3 Simple Steps</strong></h1>
              <div className="row">
                <div className="column">
                  <div className="about-icon">
                    <FaUpload color="white" size="22"/>
                  </div>
                  <h1>Connect</h1>
                  <p>Connect any Google Sheet that you use to sort and manage large collections of content or data.</p>
                </div>
                <div className="column">
                  <div className="about-icon">
                    <FaPlus color="white" size="22"/>
                  </div>
                  <h1>Create</h1>
                  <p>Sheet2Feed automatically converts your sheet content into a social media-like, feed-based website.</p>
                </div>
                <div className="column">
                  <div className="about-icon">
                    <FaPen color="white" size="22"/>
                  </div>
                  <h1>Update</h1>
                  <p>The items in your feed will update automatically as you change/add content to your Google Sheet.</p>
                </div>
            </div>
          </div>

          <div className="customize">
            <h1>Make Your Feed Unique</h1>
            <p className="customize-sub">Five powerful customizations to match your brand and workflow.</p>
            <div className="customize-grid">
              <div className="customize-card">
                <div className="customize-icon"><FaTag size={18}/></div>
                <h3>Title &amp; Alias</h3>
                <p>Give your feed a custom name and a memorable short URL.</p>
              </div>
              <div className="customize-card">
                <div className="customize-icon"><FaPalette size={18}/></div>
                <h3>Color Theme</h3>
                <p>Pick any brand color and choose between light and dark mode.</p>
              </div>
              <div className="customize-card">
                <div className="customize-icon"><FaThLarge size={18}/></div>
                <h3>Structure</h3>
                <p>Map spreadsheet columns to headline, description, and footer fields.</p>
              </div>
              <div className="customize-card">
                <div className="customize-icon"><FaFilter size={18}/></div>
                <h3>Filters</h3>
                <p>Let readers filter feed items by any column in your sheet.</p>
              </div>
              <div className="customize-card">
                <div className="customize-icon"><FaLock size={18}/></div>
                <h3>Password Protection</h3>
                <p>Restrict access to your feed with a password for private sharing.</p>
              </div>
            </div>
          </div>
          <div className="footer">
            <h1>Ready to get started?</h1>
            <a className="footerButton" href={window.location.origin + "/signup"}>Sign Up Today</a>
            <br /><br />

            <div className="footerLinks">
              <a href="/pricing">Pricing</a>
              <a href="#about">About</a>
              <a href="mailto:ronen@ronenjain.com">Contact</a>
            </div>

            <p>© 2026 Sheet2Feed. All rights reserved.</p>
          </div>
        </header>
      </div>
    );
}

export default Home;